<template>
  <div id="app">
     <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>


export default {
  name: 'app',
  data(){
    return { }
  },
  created(){
    // localStorage.setItem('token',this.$route.query.token)
  }
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  width: 100%;
  background: #eee;
}
.container{
    width:100%!important;
    max-width: 100%!important;
    height: 100vh;
    padding: 0 !important;
    margin: 0 !important;
}
.v-note-wrapper .v-note-panel .v-note-show .v-show-content{
  background: transparent !important;
}
.v-note-wrapper.shadow{
  background: transparent !important;
  color: #000 !important;
}
.markdown-body{
  font-size: 16px !important;
}
.hljs{
  background: transparent !important;
}
.markdown-body pre{
  background: transparent !important;
}
</style>
